import { checkPayeeNameHavAcc, getCleanPayeeName } from "./helperFunctions";

const { axios_instance } = require("../api/axios_instance");
const {
  checkHoldCase,
  holdCaseMessage,
  getCompletedStepDetails,
} = require("./detail");
const {
  RestrictAccounts,
  PaymentTrancheRequiredTriggers,
  ControlTypes,
  RphUserIds,
  ControlClass,
  OfflinePaymentModes,
} = require("./constant");
const { encryptRequest, decryptRequest } = require("./encryptdecryptrequest");

const validateOTPFunction = async (
  e,
  idx,
  formFieldState,
  setFormFieldState,
  state,
  setState,
  lead_id,
) => {
  const { id } = e.target;
  const payee_account = formFieldState[idx].payee_ac_number;
  const otp = formFieldState[idx].otp;
  if (id === "validateAccountBtn") {
    let payee_name = formFieldState[idx].payeeNameVal;
    if (
      OfflinePaymentModes.includes(formFieldState[idx]?.payment_mode) &&
      checkPayeeNameHavAcc(payee_name)
    ) {
      payee_name = getCleanPayeeName(payee_name);
    }
    formFieldState[idx][`disabled_${id}`] = true;
    setFormFieldState([...formFieldState]);
    try {
      let result = await axios_instance({
        url: "/dts/validateOTP",
        method: "POST",
        data: {
          lead_id,
          payee_name,
          payee_account,
        },
      });
      result = result.data.response;
      if (result.status) {
        formFieldState[idx].errorConfirmPayeeAcNumberClass = "text-success";
        formFieldState[idx].errorconfirmPayeeAcNumberMsg = result.msg;

        setFormFieldState([...formFieldState]);
        setState({ ...state, disabled_authTrancheBtn: false });
      } else {
        formFieldState[idx].errorConfirmPayeeAcNumberClass = "errorTxt";
        formFieldState[idx].errorconfirmPayeeAcNumberMsg = result.msg;

        formFieldState[idx][`disabled_${id}`] = false;
        setFormFieldState([...formFieldState]);
        setState({ ...state, disabled_authTrancheBtn: true });
      }
    } catch (error) {}
    return;
  }
  if (payee_account === otp) {
    formFieldState[idx].disabled_validateOTPBtn = true;
    formFieldState[idx].disabled_otp = true;
    formFieldState[idx].validateOTPClass = "text-success";
    formFieldState[idx].validateOTPMsg = "OTP Validated.";
    setState({ ...state, disabled_approveTrancheBtn: false });
  } else {
    formFieldState[idx].validateOTPClass = "text-danger";
    formFieldState[idx].validateOTPMsg = "Wrong OTP! Please Try Again.";
  }
  setFormFieldState([...formFieldState]);
};

const addUTRFunction = async (
  idx,
  formFieldState,
  setFormFieldState,
  caseDetails,
  max_pay_count,
) => {
  const utr = formFieldState[idx].payable_rtgs_cheque_number;
  if (!utr) {
    formFieldState[idx].payableRtgsChequeNumberClass = "errorInput";
    setFormFieldState([...formFieldState]);
    return { msg: "Please Enter utr no.", error: true };
  }
  formFieldState[idx].disabled_utrNoBtn = true;
  setFormFieldState([...formFieldState]);
  try {
    let result = await axios_instance({
      url: "/dts/addUTR",
      method: "POST",
      data: {
        finance_lead_id: caseDetails.finance_lead_id,
        disbursement_id: caseDetails.id,
        pay_count: idx + 1,
        utr,
        customer_name: caseDetails.customer_name,
        max_pay_count,
      },
    });

    result = result.data.result;

    if (result.status && result.is_duplicate_utr) {
      const msg = `Duplicate value! Exist in ${result.utr_data.loan_id} Tranche ${result.utr_data.tranche_no}`;
      appendErrorClass(idx, "payableRtgsChequeNumber", msg, formFieldState);
      formFieldState[idx].disabled_utrNoBtn = false;
      setFormFieldState([...formFieldState]);
      return { msg: false };
    }
    formFieldState[idx].payableRtgsChequeNumberReadOnly = true;
    removeErrorClass(
      idx,
      "payableRtgsChequeNumber",
      formFieldState,
      setFormFieldState,
      false,
    );
    setFormFieldState([...formFieldState]);
    return { msg: "Successfully Updated", error: false };
  } catch (error) {
    formFieldState[idx].disabled_utrNoBtn = false;
    setFormFieldState([...formFieldState]);
    return { msg: false };
  }
};

const addTrancheFunction = async (
  idx,
  formFieldState,
  setFormFieldState,
  state,
  setState,
  caseDetails,
  paymentDetails,
) => {
  const { finance_lead_id, maker_id, sub_stage } = caseDetails;
  const tuTrancheNo = state.selectedTranche || 0;

  const checkHoldStatus = await checkHoldCase(
    finance_lead_id,
    maker_id,
    sub_stage,
  );
  if (checkHoldStatus) return { msg: holdCaseMessage, error: true };
  const net_amount = formFieldState[idx - 1].disburse_bal_amt;
  const with_held_amount = formFieldState[idx - 1].with_held_charges;
  const dealer_id = caseDetails.dealer_id;
  const customer_id = caseDetails.customer_id;

  formFieldState[idx - 1].hideLastPayDiv = true;
  formFieldState[idx - 1].disabledPaymentMode = true;
  formFieldState[idx - 1].disabledPayeeType = true;
  formFieldState[idx - 1].disabledPayableAcNumber = true;
  formFieldState[idx - 1].payeeNameReadOnly = true;
  formFieldState[idx - 1].payeeAcNumberReadOnly = true;
  formFieldState[idx - 1].payeeBankNameReadOnly = true;
  formFieldState[idx - 1].payeeIfscCodeReadOnly = true;
  formFieldState[idx - 1].payeeBranchNameReadOnly = true;
  formFieldState[idx - 1].disbursePaidAmtReadOnly = true;

  setFormFieldState([...formFieldState]);
  state.showNextTrancheCell = true;
  state.hideNextTrancheDiv = true;
  state.showPayDraftBtn = true;
  state.isPartPayment = true;
  setState({ ...state });

  return {
    finance_lead_id: caseDetails.finance_lead_id,
    disbursement_id: caseDetails.id,
    stage: caseDetails.stage,
    subStage: 1,
    count: idx + 1,
    net_amount,
    with_held_amount,
    tranche_type: paymentDetails.tranche_type,
    fcm_bank_id: caseDetails.fcm_bank_id,
    dealer_id,
    customer_id,
    msg: false,
    error: false,
    tuTrancheNo,
  };
};

const balTotalFunction = (
  idx,
  formFieldState,
  state,
  setState,
  withheldCharges,
  addedTranche,
  firstRender = false,
) => {
  let disbursePaidAmt = formFieldState[idx].paidAmountVal;
  const disbursePayableAmt = formFieldState[idx].netAmountVal;
  disbursePaidAmt = disbursePaidAmt ? disbursePaidAmt : "0";
  if (isNaN(disbursePaidAmt)) return { msg: false };
  let finalTotal = parseInt(disbursePayableAmt);

  if (finalTotal < parseInt(disbursePaidAmt)) {
    formFieldState[idx].disbursePaidAmtClass = "errorInput";

    formFieldState[idx].paidAmountVal = finalTotal;
    formFieldState[idx].disburse_bal_amt = 0;
    calculateCanAndForeclosure(idx, formFieldState, state, addedTranche);
    return {
      msg: "Paid amount should not be greater than payable amount",
      error: true,
    };
  } else {
    formFieldState[idx].disbursePaidAmtClass = "";
  }
  calculateCanAndForeclosure(idx, formFieldState, state, addedTranche);
  finalTotal -= parseInt(disbursePaidAmt);
  if (!firstRender) {
    if (finalTotal > 0) {
      state.isPartialPayment = "1";
    } else {
      state.isPartialPayment = "0";
    }
    if (!addedTranche) setState({ ...state });
  }

  if (idx) {
    formFieldState[idx].with_held_charges =
      parseInt(disbursePayableAmt) - withheldCharges;
  }
  formFieldState[idx].disburse_bal_amt = finalTotal;
  return { msg: false };
};

const calculateCanAndForeclosure = (
  idx,
  formFieldState,
  state,
  addedTranche,
) => {
  let recoveredAmount = formFieldState[idx].recovered_amount;

  let disbursePaidAmt = formFieldState[idx].paidAmountVal;
  disbursePaidAmt = disbursePaidAmt ? parseInt(disbursePaidAmt) : 0;

  if (recoveredAmount) {
    if (recoveredAmount === null || isNaN(recoveredAmount)) return;
    recoveredAmount = parseInt(recoveredAmount);

    const cancellationCharges = formFieldState[idx].cancellationChargesVal
      ? parseInt(formFieldState[idx].cancellationChargesVal)
      : 0;

    const returnedAmount =
      disbursePaidAmt + recoveredAmount + cancellationCharges;
    formFieldState[idx].money_returned_to_bank = returnedAmount;
  }

  if (addedTranche) return;
  let releaseForeclosureAmount =
    formFieldState[idx].releaseForeclosureAmountVal;
  if (releaseForeclosureAmount) {
    if (isNaN(releaseForeclosureAmount)) return;
    releaseForeclosureAmount = parseInt(releaseForeclosureAmount);
    const totalForeclosureAmount = disbursePaidAmt + releaseForeclosureAmount;
    formFieldState[idx].totalForeclosureAmountVal = totalForeclosureAmount;
    const trancheForClosureData = state.paymentTrancheDetails.forClosureData[
      idx
    ]
      ? state.paymentTrancheDetails.forClosureData[idx]
      : {};
    const approvedAmount = parseInt(
      trancheForClosureData.release_foreclosure_amount,
    );

    if (approvedAmount === releaseForeclosureAmount) {
      formFieldState[idx].mismatchClass = "";
    } else {
      formFieldState[idx].mismatchClass = "col-red";
    }
  }
};

const partPaymentSubmissionFunction = async (
  idx,
  caseDetails,
  formFieldState,
  setFormFieldState,
  state,
  setState,
  type,
  stage,
  subStage,
  user,
  payleadData,
) => {
  const { finance_lead_id, maker_id, sub_stage } = caseDetails;
  const checkHoldStatus = await checkHoldCase(
    finance_lead_id,
    maker_id,
    sub_stage,
  );
  if (checkHoldStatus) return { msg: holdCaseMessage, error: true };

  const disbursePayableAmt = formFieldState[idx].netAmountVal;
  let disbursePaidAmt = formFieldState[idx].paidAmountVal;
  if (!disbursePaidAmt) {
    return { msg: "Disburse amount should not be blank", error: true };
  }
  calculateCanAndForeclosure(idx, formFieldState, state, true);
  if (
    !validatePayeeDetails(
      idx,
      state,
      formFieldState,
      setFormFieldState,
      caseDetails,
    )
  ) {
    return { msg: false };
  }

  const is_payment_received_by_bank =
    formFieldState[idx].is_payment_received_by_bank;
  let recovered_amount = 0,
    cancellation_charges = 0,
    returned_amount = 0;

  if (formFieldState[idx].recovered_amount) {
    disbursePaidAmt = parseInt(disbursePaidAmt);
    recovered_amount = parseInt(formFieldState[idx].recovered_amount);
    cancellation_charges = parseInt(formFieldState[idx].cancellationChargesVal);
    returned_amount = disbursePaidAmt + recovered_amount + cancellation_charges;
  }

  const customer_name = `${caseDetails.customer_name} ${caseDetails.last_name}`;

  const nameValidation = regexValidate(
      idx,
      "name",
      formFieldState,
      setFormFieldState,
    ),
    aplhanumericValidation = regexValidate(
      idx,
      "alphanumeric",
      formFieldState,
      setFormFieldState,
    );

  if (
    (!nameValidation || !aplhanumericValidation) &&
    formFieldState[idx].payable_ac_number !== "Direct Payment"
  ) {
    return { msg: false };
  }
  const isFloatPayment = is_payment_received_by_bank === 1;
  let confirmMessage = "";
  if (isFloatPayment && type === "submit") {
    confirmMessage =
      "Payment going through Float, Ensure proper DO is attached?";
  } else {
    confirmMessage = "Would you like to proceed?";
  }
  if (!window.confirm(confirmMessage)) return { msg: false };

  const superMaker = caseDetails.is_super_maker,
    stpPayment = caseDetails.stp_payment,
    caseType = caseDetails.case_type;
  if (
    caseType === "normal" &&
    stpPayment === 1 &&
    superMaker === 1 &&
    type === "submit"
  ) {
    setState({ ...state, showSuperMakerConfirmModal: true });
  }

  try {
    let tranche_value = formFieldState[idx].tranche_value,
      tranche_name = formFieldState[idx].tranche_name;

    if (typeof tranche_name === "string") {
      tranche_value = 0;
      tranche_name = {};
      formFieldState[idx].trancheNameListData.forEach((value) => {
        if (!value.isChecked) {
          tranche_name.deselected = {
            ...tranche_name.deselected,
            [value.label]: value.amount,
          };
        } else {
          tranche_name.selected = {
            ...tranche_name.selected,
            [value.label]: value.amount,
          };
          tranche_value += parseInt(value.amount);
        }
      });
    }

    const result = await axios_instance({
      url: "/dts/partPaymentSubmission",
      method: "POST",
      data: {
        pay_count: idx + 1,
        finance_lead_id: caseDetails.finance_lead_id,
        disbursement_id: caseDetails.id,
        disburse_payable_amt: disbursePayableAmt,
        disburse_paid_amt: disbursePaidAmt,
        disburse_bal_amt: formFieldState[idx].disburse_bal_amt,
        payable_ac_number: formFieldState[idx].payable_ac_number,
        payee_ac_number: formFieldState[idx].payee_ac_number,
        confirm_payee_ac_number: formFieldState[idx].confirmPayeeAcNumber,
        payable_rtgs_cheque_number:
          formFieldState[idx].payable_rtgs_cheque_number,
        dealer_ack: 0,
        stage,
        sub_stage: subStage.toString(),
        bank_name: caseDetails.bank_name,
        regno: caseDetails.regno,
        lead_city: caseDetails.lead_city,
        customer_name,
        payment_mode: formFieldState[idx].payment_mode,
        payee_type: formFieldState[idx].payeeTypeVal,
        payee_name: formFieldState[idx].payeeNameVal,
        payee_bank_name: formFieldState[idx].payee_bank_name,
        payee_ifsc_code: formFieldState[idx].payee_ifsc_code,
        payee_branch_name: formFieldState[idx].payee_branch_name,
        devition_reason_id: formFieldState[idx].devition_reason_id,
        type,
        checker_id: user.id,
        is_payment_received_by_bank,
        float_doc_id: formFieldState[idx].float_doc_id || state?.paymentTrancheDetails?.floatResp?.document_id || 0,
        with_held_amount: formFieldState[idx].with_held_charges,
        tranche_value: tranche_value,
        tranche_name: tranche_name,
        save_as_draft: 1,
        tu_tranche_no: formFieldState[idx]?.selectedTranche,
        paylead_limit: payleadData.payleadLimit,
        paylead_user_id: payleadData.payleadUserId,
        recovered_amount,
        cancellation_charges,
        money_returned_to_bank: returned_amount,
        previous_financier: formFieldState[idx].previous_financier,
        previous_loan_account: formFieldState[idx].previous_loan_account,
        float_status: formFieldState[idx].float_status || (state?.paymentTrancheDetails?.floatResp?.float_status
          ? state.paymentTrancheDetails.floatResp.float_status
          : 0),
        sm_action: state.sm_action ? state.sm_action : "",
        stp_payment: caseDetails.stp_payment,
        case_type: caseType,
        maker_id: caseDetails.maker_id,
        action: "part_pay",
      },
    });
    setState({ ...state, showSuperMakerConfirmModal: false });

    if (result.status === 200) {
      return { msg: "Details has been saved successfully.", error: false };
    }
  } catch (error) {
    return { msg: error.response.data.message, error: true };
  }
};

const makerSubmissionFunction = async (
  idx,
  formFieldState,
  setFormFieldState,
  state,
  setState,
  type,
  stage,
  subStage,
  caseDetails,
  user,
  formName,
  payleadData,
) => {
  const { finance_lead_id, maker_id, sub_stage } = caseDetails;
  const checkHoldStatus = await checkHoldCase(
    finance_lead_id,
    maker_id,
    sub_stage,
  );
  if (checkHoldStatus) return { msg: holdCaseMessage, error: true };

  calculateCanAndForeclosure(idx, formFieldState, state, true);

  if (
    !validatePayeeDetails(
      idx,
      state,
      formFieldState,
      setFormFieldState,
      caseDetails,
    )
  ) {
    return { msg: false };
  }

  const nameValidation = regexValidate(
      idx,
      "name",
      formFieldState,
      setFormFieldState,
    ),
    aplhanumericValidation = regexValidate(
      idx,
      "alphanumeric",
      formFieldState,
      setFormFieldState,
    ),
    numberValidation = regexValidate(
      idx,
      "number",
      formFieldState,
      setFormFieldState,
    ),
    specialValidation = regexValidate(
      idx,
      "special",
      formFieldState,
      setFormFieldState,
    );

  if (
    (!nameValidation ||
      !aplhanumericValidation ||
      !numberValidation ||
      !specialValidation) &&
    formFieldState[idx].payable_ac_number !== "Direct Payment"
  ) {
    setFormFieldState([...formFieldState]);
    return { msg: false };
  }
  setFormFieldState([...formFieldState]);

  const superMaker = caseDetails.is_super_maker,
    stpPayment = caseDetails.stp_payment,
    caseType = caseDetails.case_type,
    makerId = caseDetails.maker_id;

  const isFloatPayment = +formFieldState[idx].is_payment_received_by_bank === 1;
  if (isFloatPayment && type === "submit") {
    if (
      !window.confirm(
        "Payment going through Float, Ensure proper DO is attached?",
      )
    )
      return { msg: false };
  }

  if (
    caseType === "normal" &&
    +stpPayment === 1 &&
    +superMaker === 1 &&
    type === "submit"
  ) {
    setState({ ...state, showSuperMakerConfirmModal: true });
  }

  const params = {};

  if (state.isPartialPayment)
    params.is_partial_payment = state.isPartialPayment;

  fillFormValues(params, formFieldState, idx);

  try {
    const stepDetails = getCompletedStepDetails(
      caseDetails.step_details,
      subStage,
      "payment_tranche",
    );
    const result = await axios_instance({
      url: "/dts/makerSubmission",
      method: "POST",
      data: {
        step_details: stepDetails,
        bank_id: caseDetails.fcm_bank_id,
        finance_lead_id: caseDetails.finance_lead_id,
        disbursement_id: caseDetails.id,
        type,
        stage,
        sub_stage: subStage.toString(),
        ...params,
        bank_name: caseDetails.bank_name,
        regno: caseDetails.regno,
        lead_city: caseDetails.lead_city,
        checker_id: type === "submit" ? user.id : "",
        customer_name: caseDetails.customer_name,
        form_id: formName,
        save_net_amount: "NA",
        save_as_draft: 1,
        stp_payment: caseDetails.stp_payment,
        case_type: caseType,
        maker_id: makerId,
        paylead_limit: payleadData.payleadLimit,
        paylead_user_id: payleadData.payleadUserId,
        action: "maker",
        pay_count: idx + 1,
        sm_action: state.sm_action ? state.sm_action : "",
        float_status: formFieldState[idx].float_status || (state?.paymentTrancheDetails?.floatResp?.float_status
          ? state.paymentTrancheDetails.floatResp.float_status
          : 0),
        float_doc_id: formFieldState[idx].float_doc_id || state?.paymentTrancheDetails?.floatResp?.document_id || 0,
      },
    });
    setState({ ...state, showSuperMakerConfirmModal: false });

    if (result.status === 200) {
      return { msg: "Details has been saved successfully.", error: false };
    }
  } catch (error) {
    return { msg: error?.response?.data?.message, error: true };
  }
};

const superMakerSubmissionFunction = async (
  formFieldState,
  setFormFieldState,
  state,
  setState,
  type,
  subStage,
  caseDetails,
  formName,
  payleadData,
  paymentDetails,
  control_type,
  tranche_reasons,
  cond = false,
  disable,
) => {
  state.sm_action = subStage;
  if (
    !validateTuAccount(
      formFieldState.length - 1,
      formFieldState,
      state,
      caseDetails,
    )
  ) {
    setState({ ...state });
    return { msg: false };
  }
  const result = await checkerValidateFunction(
    formFieldState.length - 1,
    formFieldState,
    setFormFieldState,
    state,
    setState,
    caseDetails,
    "payment_tranche",
    cond,
    disable,
  );

  if (result && result.error) return result;

  if (["5", "7", "8"].includes(caseDetails.sub_stage)) {
    const result = await otherSubmissionFunction(
      formFieldState,
      state,
      setState,
      type,
      1,
      5,
      caseDetails,
      formName,
      payleadData,
      paymentDetails,
      control_type,
      tranche_reasons,
      true,
    );
    return result;
  }
  return { msg: false };
};

const checkerValidateFunction = async (
  idx,
  formFieldState,
  setFormFieldState,
  state,
  setState,
  caseDetails,
  stepSelected,
  cond = false,
  disable,
) => {
  const { finance_lead_id, maker_id, sub_stage } = caseDetails;
  const checkHoldStatus = await checkHoldCase(
    finance_lead_id,
    maker_id,
    sub_stage,
  );
  if (checkHoldStatus) return { msg: holdCaseMessage, error: true };
  if (
    !validatePayeeDetails(
      idx,
      state,
      formFieldState,
      setFormFieldState,
      caseDetails,
    )
  ) {
    return { msg: false, error: true };
  }

  if (!checkBoxValidations(idx, formFieldState, state, stepSelected, disable)) {
    setFormFieldState([...formFieldState]);
    setState({ ...state, showAmountMismatchModal: false });
    return { msg: "Please check all Check Boxes fields.", error: true };
  }

  // setState({ ...state, showAmountMismatchModal: false });
  const is_part_payment = state.isPartialPayment;
  const disbDetails = await getCurrentDisbursementAmount(
    caseDetails.finance_lead_id,
  );

  let netAmount = 0,
    totalReleaseAmt = 0;
  if (disbDetails) netAmount = disbDetails.lead_disbursed_amt;

  formFieldState.forEach((payment) => {
    totalReleaseAmt += payment.paidAmountVal ? +payment.paidAmountVal : 0;
  });

  const balance_amount = formFieldState[idx].disburse_bal_amt;

  if (!cond && netAmount != null) {
    if (
      !cond &&
      netAmount < parseInt(totalReleaseAmt) + parseInt(balance_amount)
    ) {
      state.mismatchBtnClickFunc = "checkerValidate";
      setState({ ...state, showAmountMismatchModal: true });
      return { msg: false };
    } else {
      return await checkerValidateFunction(
        idx,
        formFieldState,
        setFormFieldState,
        state,
        setState,
        caseDetails,
        stepSelected,
        true,
        disable,
      );
    }
  }

  // if (+is_part_payment === 1) {
  const total_withheld_amt = formFieldState[idx].with_held_charges;

  const commonStateUpdate = {
    showWithheldChargesModal: true,
    withHeldChargesInputDisabled: false,
    withHeldChargesBtnDisplay: true,
    withHeldChargesPayCount: idx + 1,
    withHeldChargesAdjustmentAmount: balance_amount,
    withHeldChargesAdjustmentChargesDisplay: true,
    withHeldChargesAction: "auto",
    showAmountMismatchModal: false,
  };

  const { id } = caseDetails;
  let withheldChargesResp = await axios_instance({
    url: "/dts/getWithHeldCharges",
    method: "POST",
    data: { pay_count: 1, finance_lead_id, disbursement_id: id },
    action: "getWithHeldCharges",
  });
  withheldChargesResp = withheldChargesResp.data.result;
  let adjustmentAmount = balance_amount - state.totalWithheldCharges;
  Object.keys(withheldChargesResp).forEach((input) => {
    if (withheldChargesResp[`is_${input}`] === "checked") {
      adjustmentAmount -= parseInt(withheldChargesResp[input]);
    }
  });
  if (
    idx === 0 &&
    +total_withheld_amt !== +balance_amount &&
    parseInt(adjustmentAmount) !== 0
  ) {
    state = {
      ...state,
      ...commonStateUpdate,
    };
    setState(state);
    return { msg: false };
  } else if (
    idx !== 0 &&
    +total_withheld_amt !== +balance_amount &&
    parseInt(adjustmentAmount) !== 0
  ) {
    state = {
      ...state,
      ...commonStateUpdate,
      withHeldChargesCheckboxVal: false,
      withHeldChargesOtherReasonDisplay: false,
    };
    setState(state);
    return { msg: false };
  }
  // }
  setState({
    ...state,
    showAssignCheckerModal: true,
    showAmountMismatchModal: false,
  });
  return { msg: false };
};

const getCurrentDisbursementAmount = async (lead_id) => {
  if (!lead_id) return null;
  let response = {};
  try {
    const resp = await axios_instance({
      url: "/dts/getDisbursementDetail",
      method: "POST",
      data: {
        lead_id,
      },
    });
    if (resp.status === 200) response = resp.data.result;
  } catch (error) {}
  return response;
};

const otherSubmissionFunction = async (
  formFieldState,
  state,
  setState,
  type,
  stage,
  subStage,
  caseDetails,
  formName,
  payleadData,
  paymentDetails,
  control_type,
  tranche_reasons,
  cond = false,
) => {
  setState({ ...state, showApprovePaymentModal: false });

  if (!stage || !subStage) {
    window.alert("No Stage or substage stored. So contact to DTS admin.");
    return { msg: false };
  }

  let cancel_reason = "";
  if (+subStage === 10) {
    cancel_reason = state.cancelReason;
    if (!cancel_reason) {
      return { msg: "Please select cancellation reason", error: true };
    }
  }

  let resp = false;
  if (
    (type === "submit" && ["dtStage1", "dtStage3"].includes(formName)) ||
    cond
  ) {
    resp = true;
  } else if (
    type === "submit" &&
    formName === "dtStage2" &&
    [6, 7, 8, 9].includes(+subStage)
  ) {
    const netAmount = caseDetails.lead_disbursed_amt;
    if (
      caseDetails.TotalTranchAmount &&
      caseDetails.with_held_amount &&
      netAmount
    ) {
      if (
        !cond &&
        netAmount <
          parseInt(caseDetails.TotalTranchAmount) +
            parseInt(caseDetails.with_held_amount)
      ) {
        setState((prevState) => ({
          ...prevState,
          showAmountMismatchModal: true,
        }));
      } else {
        const floatPayment =
          formFieldState[formFieldState.length - 1].is_payment_received_by_bank;
        resp =
          floatPayment === 1
            ? window.confirm(
                "Payment going through Float, Ensure proper DO is attached?",
              )
            : window.confirm("Would you like to proceed?");
      }
    } else {
      resp = window.confirm("Would you like to proceed?");
    }
  } else {
    resp = window.confirm("Would you like to proceed?");
  }

  if (resp) {
    setState((prevState) => ({ ...prevState, showAmountMismatchModal: false }));
    try {
      let result = await axios_instance({
        url: "/dts/otherSubmission",
        method: "POST",
        data: {
          action: "others",
          disbursement_id: caseDetails.id,
          finance_lead_id: caseDetails.finance_lead_id,
          fcm_bank_id: caseDetails.fcm_bank_id,
          type,
          stage,
          sub_stage: subStage,
          bank_name: caseDetails.bank_name,
          regno: caseDetails.regno,
          ops_bank_id: caseDetails.ops_bank_id,
          lead_city: caseDetails.lead_city,
          cancel_reason,
          customer_name: `${caseDetails.customer_name} ${caseDetails.last_name}`,
          pay_count: paymentDetails.length,
          tranche_type: ControlTypes.indexOf(control_type).toString(),
          tranche_reasons,
          paylead_limit: payleadData.payleadLimit,
          paylead_user_id: payleadData.payleadUserId,
          case_type: caseDetails.case_type,
          net_disbursement_amount: caseDetails.net_disbursement_amount,
          city_id: caseDetails.city_id,
          auth_otp: formFieldState[formFieldState.length - 1].otp,
          tranche_number: paymentDetails[caseDetails.dts_pay_count - 1].id,
          is_super_maker: caseDetails.is_super_maker,
          stp_payment: caseDetails.stp_payment,
          maker_id: caseDetails.maker_id,
          float_status: formFieldState[formFieldState.length - 1].float_status || (state?.paymentTrancheDetails?.floatResp?.float_status
            ? state.paymentTrancheDetails.floatResp.float_status
            : 0),
          float_doc_id:
            formFieldState[formFieldState.length - 1].float_doc_id || state?.paymentTrancheDetails?.floatResp?.document_id || 0,
        },
      });

      if (result.status === 200) {
        result = result.data.result;
        return { msg: result.msg, error: false };
      }
      return { msg: result.msg, error: true };
    } catch (error) {
      return { msg: error?.response?.data?.message, error: true };
    }
  }
  return { msg: false };
};

const validateTuAccount = (idx, formFieldState, state, caseDetails) => {
  const commonCondition =
    caseDetails.is_super_maker === 1 &&
    formFieldState[idx].showValidateAccountBtn;
  if (
    commonCondition &&
    formFieldState[idx].existed_payee_name !== formFieldState[idx].payeeNameVal
  ) {
    formFieldState[idx].disabled_validateAccountBtn = false;
    state.disabled_authTrancheBtn = true;
    appendErrorClass(
      idx,
      "payeeName",
      "Please Re-validate Payee Name!",
      formFieldState,
    );
    return false;
  } else if (
    commonCondition &&
    formFieldState[idx].existed_payee_account !==
      formFieldState[idx].payee_ac_number
  ) {
    formFieldState[idx].disabled_validateAccountBtn = false;
    state.disabled_authTrancheBtn = true;
    appendErrorClass(
      idx,
      "payeeAccountNo",
      "Please Re-validate Account Number!",
      formFieldState,
    );
    return false;
  }
  return true;
};

const validatePayeeDetails = (
  idx,
  state,
  formFieldState,
  setFormFieldState,
  caseDetails,
) => {
  let validationFlag = true;
  let validationOfflineFlag = true;
  const payableAcNumber = formFieldState[idx].payable_ac_number;
  const offPaymentMode = formFieldState[idx].payment_mode;
  let isCancelltionTranche = false;
  const foreclosureAmount = parseInt(
    formFieldState[idx]?.releaseForeclosureAmountVal,
  );

  const lastCancellationDataArr =
    state.paymentTrancheDetails?.cancellationData?.[idx] || [];
  if (
    (Array.isArray(lastCancellationDataArr) &&
      lastCancellationDataArr.length > 1) ||
    (!Array.isArray(lastCancellationDataArr) &&
      Object.keys(lastCancellationDataArr).length > 1)
  ) {
    isCancelltionTranche = true;
  }

  const isCollectionOrForeclosureOrCancellation =
    isCancelltionTranche ||
    (!isNaN(foreclosureAmount) && foreclosureAmount > 0);

  [
    "payableAcNumber",
    "paymentMode",
    "payeeType",
    "payeeName",
    "payeeAccountNo",
    "confirmPayeeAcNumber",
    "payeeIFSC",
    "payeeBankName",
    "payeeBranchName",
    "disbursePaidAmt",
  ].forEach((classId) => {
    removeErrorClass(idx, classId, formFieldState, setFormFieldState, false);
  });

  if (
    !payableAcNumber ||
    !state.payerAccount.find((acc) => acc.value === payableAcNumber)
  ) {
    appendErrorClass(
      idx,
      "payableAcNumber",
      "Please select Payer A/C.",
      formFieldState,
    );
    setFormFieldState([...formFieldState]);
    return false;
  }
  if (payableAcNumber === "Direct Payment") {
    validationFlag = false;
    validationOfflineFlag = false;
  }

  if (
    OfflinePaymentModes.includes(offPaymentMode) &&
    !isCollectionOrForeclosureOrCancellation
  ) {
    validationFlag = false;
    if (!checkPayeeNameHavAcc(formFieldState[idx]?.payeeNameVal)) {
      validationOfflineFlag = false;
    }
  }

  if (!formFieldState[idx].payment_mode && validationFlag) {
    appendErrorClass(
      idx,
      "paymentMode",
      "Please fill the mandatory information",
      formFieldState,
    );
    setFormFieldState([...formFieldState]);
    return false;
  } else if (!formFieldState[idx].payeeTypeVal) {
    appendErrorClass(
      idx,
      "payeeType",
      "Please fill the mandatory information",
      formFieldState,
    );
    setFormFieldState([...formFieldState]);
    return false;
  } else if (!formFieldState[idx].payeeNameVal) {
    appendErrorClass(
      idx,
      "payeeName",
      "Please fill the mandatory information",
      formFieldState,
    );
    setFormFieldState([...formFieldState]);
    return false;
  } else if (!formFieldState[idx].payee_ac_number && validationFlag) {
    appendErrorClass(
      idx,
      "payeeAccountNo",
      "Please fill the mandatory information",
      formFieldState,
    );
    setFormFieldState([...formFieldState]);
    return false;
  } else if (
    !formFieldState[idx].confirmPayeeAcNumber &&
    (validationFlag || validationOfflineFlag)
  ) {
    appendErrorClass(
      idx,
      "confirmPayeeAcNumber",
      "Please fill the mandatory information",
      formFieldState,
    );
    setFormFieldState([...formFieldState]);
    return false;
  } else if (
    formFieldState[idx].confirmPayeeAcNumber !==
      formFieldState[idx].payee_ac_number &&
    (validationFlag || validationOfflineFlag)
  ) {
    appendErrorClass(
      idx,
      "confirmPayeeAcNumber",
      "Account Number Mismatch!",
      formFieldState,
    );
    setFormFieldState([...formFieldState]);
    return false;
  } else if (!formFieldState[idx].payee_ifsc_code && validationFlag) {
    appendErrorClass(
      idx,
      "payeeIFSC",
      "Please fill the mandatory information",
      formFieldState,
    );
    setFormFieldState([...formFieldState]);
    return false;
  } else if (!formFieldState[idx].payee_bank_name && validationFlag) {
    appendErrorClass(
      idx,
      "payeeBankName",
      "Please fill the mandatory information",
      formFieldState,
    );
    setFormFieldState([...formFieldState]);
    return false;
  } else if (!formFieldState[idx].payee_branch_name && validationFlag) {
    appendErrorClass(
      idx,
      "payeeBranchName",
      "Please fill the mandatory information",
      formFieldState,
    );
    setFormFieldState([...formFieldState]);
    return false;
  } else if (
    !formFieldState[idx].paidAmountVal &&
    validationFlag &&
    caseDetails.is_super_maker
  ) {
    appendErrorClass(
      idx,
      "disbursePaidAmt",
      "Please fill the mandatory information",
      formFieldState,
    );
    setFormFieldState([...formFieldState]);
    return false;
  } else if (
    validationFlag &&
    RestrictAccounts.includes(formFieldState[idx].payee_ac_number)
  ) {
    appendErrorClass(
      idx,
      "disbursePaidAmt",
      "A/C blocked for payment! please recheck.",
      formFieldState,
    );
    setFormFieldState([...formFieldState]);
    return false;
  }

  return true;
};

const regexValidate = (
  idx,
  validationType,
  formFieldState,
  setFormFieldState,
) => {
  let result = true,
    regex = "";

  const NameValidationFields = [
    {
      fieldVal: "payeeNameVal",
      errorMsg: "errorpayeeNameMsg",
      fieldClass: "payeeNameClass",
    },
    {
      fieldVal: "payee_bank_name",
      errorMsg: "errorpayeeBankNameMsg",
      fieldClass: "payeeBankNameClass",
    },
  ];

  const AlphanumericValidationFields = [
    {
      fieldVal: "payee_ifsc_code",
      errorMsg: "errorpayeeIFSCMsg",
      fieldClass: "payeeIFSCClass",
    },
    {
      fieldVal: "payable_rtgs_cheque_number",
      errorMsg: "errorpayableRtgsChequeNumberMsg",
      fieldClass: "payableRtgsChequeNumberClass",
    },
  ];

  const NumberValidationFields = [
    {
      fieldVal: "paidAmountVal",
      errorMsg: "errordisbursePaidAmtMsg",
      fieldClass: "disbursePaidAmtClass",
    },
  ];

  const SpecialAplhanumericValidationFields = [];
  const offPaymentMode = formFieldState[idx].payment_mode;

  if (OfflinePaymentModes.includes(offPaymentMode)) return (result = true);

  switch (validationType) {
    case "name":
      NameValidationFields.forEach((fieldObj) => {
        let { fieldVal, errorMsg, fieldClass } = fieldObj;
        const val = formFieldState[idx][fieldVal];
        if (!val) {
          formFieldState[idx][fieldClass] = "errorInput";
          formFieldState[idx][errorMsg] = "Please enter valid name";
          result = false;
        }
      });
      break;
    case "alphanumeric":
      regex = new RegExp("^[a-zA-Z0-9 ]+$");
      AlphanumericValidationFields.forEach((fieldObj) => {
        let { fieldVal, errorMsg, fieldClass } = fieldObj;
        const val = formFieldState[idx][fieldVal];
        if (val) {
          if (!regex.test(val)) {
            formFieldState[idx][fieldClass] = "errorInput";
            formFieldState[idx][errorMsg] =
              "Enter aplhanumeric characters only";
            result = false;
          }
        }
      });
      break;
    case "number":
      regex = new RegExp("^[0-9]+(.[0-9]{1,2})?$");
      NumberValidationFields.forEach((fieldObj) => {
        let { fieldVal, errorMsg, fieldClass } = fieldObj;
        const val = formFieldState[idx][fieldVal];
        if (val) {
          if (!regex.test(val)) {
            formFieldState[idx][fieldClass] = "errorInput";
            formFieldState[idx][errorMsg] = "Enter numeric characters only";
            result = false;
          }
        }
      });
      break;
    case "special":
      regex = new RegExp("^[a-zA-Z0-9_/#-]+$");
      SpecialAplhanumericValidationFields.forEach((fieldObj) => {
        let { fieldVal, errorMsg, fieldClass } = fieldObj;
        const val = formFieldState[idx][fieldVal];
        if (val) {
          if (!regex.test(val)) {
            formFieldState[idx][fieldClass] = "errorInput";
            formFieldState[idx][errorMsg] =
              "Enter aplhanumeric characters only";
            result = false;
          }
        }
      });
      break;
    default:
      break;
  }
  setFormFieldState([...formFieldState]);
  return result;
};

const checkBoxValidations = (
  idx,
  formFieldState,
  state,
  stepSelected,
  disable,
) => {
  const trancheCancellationData = state.paymentTrancheDetails.cancellationData[
    idx
  ]
    ? state.paymentTrancheDetails.cancellationData[idx]
    : {};
  const trancheForClosureData = state.paymentTrancheDetails.forClosureData[idx]
    ? state.paymentTrancheDetails.forClosureData[idx]
    : {};
  let isCorrect = true;
  switch (stepSelected) {
    case "payment_tranche":
      PaymentTrancheRequiredTriggers.forEach((trigger) => {
        if (trigger.common) {
          const value = state[`${trigger.name}trigger`];
          if (
            +state.isPartialPayment !== 1 &&
            trigger.name === "with_held_amount"
          )
            return;
          if ((value === null || value === undefined) && !disable) {
            state[`show${trigger.errClass}TriggerError`] = true;
            isCorrect = false;
          } else {
            state[`show${trigger.errClass}TriggerError`] = false;
          }
          return;
        }
        if (
          trigger.cancellationTrigger &&
          Object.keys(trancheCancellationData).length <= 1
        ) {
          return;
        }
        if (
          trigger.foreclosureTrigger &&
          !(
            idx === 0 &&
            Object.keys(trancheForClosureData).length &&
            trancheForClosureData.release_foreclosure_amount > 0
          )
        ) {
          return;
        }
        const value = formFieldState[idx][`${trigger.name}trigger`];
        if (value === null || value === undefined) {
          if (formFieldState[idx].payable_ac_number === "Direct Payment") {
            const excludedFields = [
              "is_payment_received_by_bank",
              "payment_mode",
              "payee_ac_number",
              "payee_ifsc_code",
              "payee_bank_name",
              "payee_branch_name",
            ];
            if (excludedFields.includes(trigger.name)) {
              return;
            }
          }
          const isCancellation =
            Object.keys(trancheCancellationData).length > 1;

          const isForeclosure =
            idx === 0 &&
            Object.keys(trancheForClosureData).length &&
            trancheForClosureData.release_foreclosure_amount > 0;
          if (!isCancellation && !isForeclosure) {
            if (
              OfflinePaymentModes.includes(formFieldState[idx].payment_mode)
            ) {
              const excludedFields = [
                "payee_ac_number",
                "payee_ifsc_code",
                "payee_bank_name",
              ];
              if (excludedFields.includes(trigger.name)) {
                return;
              }
            }
          }

          if (trigger.name === "tranche_name") return;
          formFieldState[idx][`show${trigger.errClass}TriggerError`] = true;
          isCorrect = false;
        } else {
          formFieldState[idx][`show${trigger.errClass}TriggerError`] = false;
        }
      });
      break;
    default:
      break;
  }
  return isCorrect;
};

const getPayerAcVal = async (idx, formFieldState, caseDetails) => {
  let floatPayment = "",
    payment_mode = "",
    payee_type = "",
    current_payable_acc = "",
    payable_ac_number = "";
  floatPayment = formFieldState[idx].is_payment_received_by_bank
    ? formFieldState[idx].is_payment_received_by_bank
    : 0;
  payment_mode = formFieldState[idx].payment_mode;
  payee_type = formFieldState[idx].payeeTypeVal;
  current_payable_acc = formFieldState[idx].current_payable_acc
    ? formFieldState[idx].current_payable_acc
    : "";
  payable_ac_number = formFieldState[idx].payable_ac_number
    ? formFieldState[idx].payable_ac_number
    : formFieldState[idx].defaultPayer
      ? formFieldState[idx].defaultPayer
      : "";
  try {
    if (
      payee_type &&
      floatPayment !== null &&
      floatPayment !== undefined &&
      payment_mode
    ) {
      const response = await axios_instance({
        url: "/dts/getPayerAccount",
        method: "POST",
        data: {
          is_payment_received_by_bank: floatPayment,
          payment_mode,
          payee_type,
          pay_count: idx + 1,
          disbursement_id: caseDetails.id,
          bank_id: caseDetails.fcm_bank_id,
          finance_lead_id: caseDetails.finance_lead_id,
          sub_stage: caseDetails.sub_stage,
          current_payable_acc,
          payable_ac_number,
        },
      });
      if (response.status === 200) {
        formFieldState[idx].payable_ac_number = response.data.result;
      }
    }
  } catch (error) {}
};

const autoFillByIfsc = async (idx, ifsc, formFieldState) => {
  try {
    const response = await axios_instance({
      url: "/dts/ifscMapping",
      method: "POST",
      data: { ifsc },
    });
    if (response.status === 200) {
      const result = response.data.result;
      formFieldState[idx].payee_bank_name = result.bank_name;
      formFieldState[idx].payee_branch_name = result.branch_name;
    } else {
      resetBankFields(idx, formFieldState);
    }
  } catch (error) {
    resetBankFields(idx, formFieldState);
  }
};

const assignChecker = async (
  idx,
  formFieldState,
  setFormFieldState,
  state,
  setState,
  type,
  stage,
  subStage,
  caseDetails,
  user,
  formName,
  payleadData,
  isPartPayment,
) => {
  const payable_ac_number = formFieldState[idx].payable_ac_number;
  const payee_type = formFieldState[idx].payeeTypeVal;
  if (
    (+payleadData.payleadLimit === 0 &&
      payable_ac_number !== "Direct Payment" &&
      +payee_type !== 7) ||
    (caseDetails.stp_payment === 1 &&
      user.is_super_maker === 1 &&
      +payee_type !== 7)
  ) {
    subStage = 7;
  }
  if (isPartPayment) {
    const result = await partPaymentSubmissionFunction(
      idx,
      caseDetails,
      formFieldState,
      setFormFieldState,
      state,
      setState,
      type,
      stage,
      subStage,
      user,
      payleadData,
    );
    return result;
  } else {
    const result = await makerSubmissionFunction(
      idx,
      formFieldState,
      setFormFieldState,
      state,
      setState,
      type,
      stage,
      subStage,
      caseDetails,
      user,
      formName,
      payleadData,
    );
    return result;
  }
};

const appendErrorClass = (idx, classId, msg, formFieldState) => {
  formFieldState[idx][`${classId}Class`] = "errorInput";
  formFieldState[idx][`error${classId}Msg`] = msg;
};

const removeErrorClass = (
  idx,
  classId,
  formFieldState,
  setFormFieldState,
  updateState = false,
) => {
  formFieldState[idx][`${classId}Class`] = "";
  formFieldState[idx][`error${classId}Msg`] = null;
  if (updateState) setFormFieldState([...formFieldState]);
};

const resetDealerProfileFields = (idx, formFieldState) => {
  formFieldState[idx].payeeNameVal = "";
  formFieldState[idx].payee_ac_number = "";
  formFieldState[idx].payee_ifsc_code = "";
  formFieldState[idx].payee_bank_name = "";
  formFieldState[idx].payee_branch_name = "";
};

const resetPaymentPrefillFields = (idx, formFieldState) => {
  formFieldState[idx].payeeNameVal = "";
  formFieldState[idx].payee_ac_number = "NA";
  formFieldState[idx].payee_ifsc_code = "NA";
  formFieldState[idx].payee_bank_name = "NA";
  formFieldState[idx].payee_branch_name = "";
};

const resetPartnerProfileFields = (idx, formFieldState) => {
  formFieldState[idx].payee_ac_number = "";
  formFieldState[idx].payee_ifsc_code = "";
  formFieldState[idx].payee_bank_name = "";
  formFieldState[idx].payee_branch_name = "";
};

const resetBankFields = (idx, formFieldState) => {
  formFieldState[idx].payee_bank_name = "";
  formFieldState[idx].payee_branch_name = "";
};

const getTrancheNo = (payCount) => {
  let trancheNo = "";
  if (payCount === 1) {
    trancheNo = "1st";
  } else if (payCount === 2) {
    trancheNo = "2nd";
  } else if (payCount === 3) {
    trancheNo = "3rd";
  } else {
    trancheNo = `${payCount}th`;
  }
  return trancheNo;
};

const getTrancheClsAndType = (payment, state, user) => {
  let trancheTypeCls = "",
    trancheType = "";
  if (payment.tranche_type !== "0" && !RphUserIds.includes(user.id)) {
    trancheType = payment.tranche_type
      ? ControlTypes[payment.tranche_type]
      : state.paymentTrancheDetails.controlSystem.type;
    trancheTypeCls = payment.tranche_type
      ? ControlClass[payment.tranche_type]
      : ControlClass[
          ControlTypes.indexOf(state.paymentTrancheDetails.controlSystem.type)
        ];
  }
  return { trancheTypeCls, trancheType };
};

const getFloatColorAndMsg = (float_status) => {
  let floatColor = "",
    floatMsg = "";
  if (float_status === 1) {
    floatColor = "green";
    floatMsg = "Float is allowed as per system.";
  } else if (float_status === 2) {
    floatColor = "red";
    floatMsg =
      "Float is blocked as per system, please double-check before using.";
  } else if (float_status === 3) {
    floatColor = "red";
    floatMsg =
      "Float policy not been checked by system, please check manually.";
  }
  return { floatColor, floatMsg };
};

const getVerifiedClsAndTxt = (payment) => {
  let verifiedCls = "",
    verifiedTxt = "";
  if (payment.payee_type === 4 || payment.payee_type === 10) {
    verifiedCls = "blue-status";
    verifiedTxt = "REQUEST NOT INITIATED";
    if (payment.tpa1_authorizer_id && payment.tpa2_authorizer_id) {
      verifiedTxt = "APPROVAL PENDING";
      if (
        payment.is_verified &&
        payment.is_tpa2_verified &&
        [1, 2].includes(payment.is_verified) &&
        [1, 2].includes(payment.is_tpa2_verified)
      ) {
        verifiedCls = "green-status";
        verifiedTxt =
          payment.is_verified === 1
            ? "APPROVED"
            : payment.is_verified === 2
              ? "AUTO APPROVED"
              : "APPROVAL PENDING";
      }
    } else {
      if (payment.is_verified != null && payment.is_verified !== "") {
        verifiedCls = [1, 2].includes(+payment.is_verified)
          ? "green-status"
          : "orange-status";
        verifiedTxt =
          payment.is_verified === 1
            ? "APPROVED"
            : payment.is_verified === 2
              ? "AUTO APPROVED"
              : "APPROVAL PENDING";
      }
    }
  }
  if (payment.payee_type === 1) {
    if (+payment?.digi_verified_acc === 1) {
      verifiedCls = "green-status";
      verifiedTxt = "DIGIPARTNER VERIFIED";
    }
  }
  return { verifiedCls, verifiedTxt };
};

const refreshFloatRuleFunction = async (state, setState, caseDetails, customPayCount = null) => {
  setState({ ...state, spinClass: "fa-spin" });
  try {
    const caseDetailsCopy = { ...caseDetails };
    if (customPayCount !== null) {
      caseDetailsCopy.dts_pay_count = customPayCount;
    }
    let reqData = encryptRequest({ caseDetails: caseDetailsCopy, refreshRule: true });
    const response = await axios_instance({
      url: "/dts/checkFloatStatus",
      method: "POST",
      data: { reqData },
    });
    if (response.status === 200) {
      let result = decryptRequest(response.data.resData);
      result = result.result;
      const floatResp = state.paymentTrancheDetails.floatResp
        ? state.paymentTrancheDetails.floatResp
        : {};
      floatResp.float_color = result.float_color;
      floatResp.float_status = result.float_status;
      floatResp.float_msg = result.float_msg;
      floatResp.is_proof_uploaded = result?.is_proof_uploaded;
      floatResp.document_id = result?.document_id;
      setState({
        ...state,
        spinClass: "",
        paymentTrancheDetails: { ...state.paymentTrancheDetails, floatResp },
      });
      return result;
    } else {
      setState({ ...state, spinClass: "" });
      return { msg: "Something went wrong", error: true };
    }
  } catch (error) {
    setState({ ...state, spinClass: "" });
    return { msg: error?.response?.data?.message, error: true };
  }
};

const changeAccTypeFunction = async (
  idx,
  state,
  formFieldState,
  caseDetails,
) => {
  const payableAcNumber = formFieldState[idx].payable_ac_number;
  if (
    +caseDetails.sub_stage === 14 &&
    (payableAcNumber === "IMPS" ||
      (state.payerAccount || []).some((acc) => acc.is_razorpay))
  ) {
    await getPayerAcVal(idx, formFieldState, caseDetails);
  }
};

const cancelPartPaymentFunction = (formFieldState) => {
  if (
    window.alert(
      "Would you like to cancel part payment. In this case balance amount should be zero.",
    )
  ) {
    formFieldState[0].disburse_bal_amt = 0;
    formFieldState[0].paidAmountVal = formFieldState[0].netAmountVal;
  }
};

const validateAccNumberFunction = (
  idx,
  formFieldState,
  setFormFieldState,
  state,
  setState,
) => {
  const payeeAccountNo = formFieldState[idx]?.payee_ac_number
    ? formFieldState[idx].payee_ac_number
    : "";
  const confirmPayeeAcNumber = formFieldState[idx]?.confirmPayeeAcNumber
    ? formFieldState[idx].confirmPayeeAcNumber
    : "";
  formFieldState[idx]["errorpayeeAccountNoMsg"] = null;
  if (
    payeeAccountNo.length &&
    RestrictAccounts.includes(payeeAccountNo.toString().trim())
  ) {
    formFieldState[idx]["errorpayeeAccountNoMsg"] =
      "A/C blocked for payment! please recheck.";
    setFormFieldState([...formFieldState]);
    return;
  }
  console.log({ payeeAccountNo, confirmPayeeAcNumber });
  if (
    payeeAccountNo.toString() !== confirmPayeeAcNumber.toString() &&
    confirmPayeeAcNumber
  ) {
    formFieldState[idx]["errorConfirmPayeeAcNumberClass"] = "errorTxt";
    formFieldState[idx]["errorconfirmPayeeAcNumberMsg"] =
      "Account Number Mismatch!";
    state.PayDraftBtnDisabled = true;
    if (formFieldState[idx].showValidateAccountBtn) {
      formFieldState[idx].disabled_validateAccountBtn = true;
    }
  } else {
    formFieldState[idx]["errorConfirmPayeeAcNumberClass"] = "";
    formFieldState[idx]["errorconfirmPayeeAcNumberMsg"] = "";
    state.PayDraftBtnDisabled = false;
    if (formFieldState[idx].showValidateAccountBtn) {
      formFieldState[idx].disabled_validateAccountBtn = false;
    }
  }
  setFormFieldState([...formFieldState]);
  setState({ ...state });
};

const ifscMappingFunction = async (idx, formFieldState) => {
  const ifsc = formFieldState[idx].payee_ifsc_code
    ? formFieldState[idx].payee_ifsc_code
    : "";
  formFieldState[idx].errorpayeeIFSCMsg = "";
  formFieldState[idx].payeeIFSCClass = "";
  if (ifsc.toString().length === 11) {
    await autoFillByIfsc(idx, ifsc, formFieldState);
  } else {
    formFieldState[idx].errorpayeeIFSCMsg =
      "IFSC code must be of 11 characters";
    formFieldState[idx].payeeIFSCClass = "errorInput";
  }
};

const compareLedgerWithDisbAmtFunction = async (
  idx,
  formFieldState,
  disbursement_id,
) => {
  const floatPayment = formFieldState[idx].is_payment_received_by_bank;
  const paidAmountVal = formFieldState[idx].paidAmountVal;
  if (floatPayment && paidAmountVal && +floatPayment === 1) {
    try {
      const response = await axios_instance({
        url: "/dts/compareLedgerWithBal",
        method: "POST",
        data: {
          tranche_amount: paidAmountVal,
          disbursement_id,
        },
      });
      if (response.status === 200) {
        return { msg: false };
      }
      return { msg: response?.data?.result?.message, error: true };
    } catch (error) {
      return { msg: error?.response?.data?.message, error: true };
    }
  }
  return { msg: false };
};

const fillFormValues = (params, formFieldState, idx) => {
  const payCount = idx + 1;
  params[`is_payment_received_by_bank_${payCount}`] =
    formFieldState[idx].is_payment_received_by_bank === 1
      ? formFieldState[idx].is_payment_received_by_bank
      : "0";
  params[`payee_type_${payCount}`] = formFieldState[idx].payeeTypeVal
    ? formFieldState[idx].payeeTypeVal
    : "";
  params[`payment_mode_${payCount}`] = formFieldState[idx].payment_mode
    ? formFieldState[idx].payment_mode
    : "";
  params[`payable_ac_number_${payCount}`] = formFieldState[idx]
    .payable_ac_number
    ? formFieldState[idx].payable_ac_number
    : "";
  params[`tranche_name_${payCount}`] = formFieldState[idx].tranche_name
    ? formFieldState[idx].tranche_name
    : "";
  params[`devition_reason_id_${payCount}`] = formFieldState[idx]
    .devition_reason_id
    ? formFieldState[idx].devition_reason_id
    : "";
  params[`previous_financier_${payCount}`] = formFieldState[idx]
    .previous_financier
    ? formFieldState[idx].previous_financier
    : "";
  params[`previous_loan_account_${payCount}`] = formFieldState[idx]
    .previous_loan_account
    ? formFieldState[idx].previous_loan_account
    : "";
  params[`payee_name_${payCount}`] = formFieldState[idx].payeeNameVal
    ? formFieldState[idx].payeeNameVal
    : "";
  params[`payee_ac_number_${payCount}`] = formFieldState[idx].payee_ac_number
    ? formFieldState[idx].payee_ac_number
    : "";
  params[`confirm_payee_ac_number_${payCount}`] = formFieldState[idx]
    .confirmPayeeAcNumber
    ? formFieldState[idx].confirmPayeeAcNumber
    : "";
  params[`payee_ifsc_code_${payCount}`] = formFieldState[idx].payee_ifsc_code
    ? formFieldState[idx].payee_ifsc_code
    : "";
  params[`payee_bank_name_${payCount}`] = formFieldState[idx].payee_bank_name
    ? formFieldState[idx].payee_bank_name
    : "";
  params[`payee_branch_name_${payCount}`] = formFieldState[idx]
    .payee_branch_name
    ? formFieldState[idx].payee_branch_name
    : "";
  params[`disburse_payable_amt_${payCount}`] = formFieldState[idx].netAmountVal
    ? formFieldState[idx].netAmountVal
    : "";
  params[`disburse_paid_amt_${payCount}`] = formFieldState[idx].paidAmountVal
    ? formFieldState[idx].paidAmountVal
    : "";
  params[`disburse_bal_amt_${payCount}`] = formFieldState[idx].disburse_bal_amt
    ? formFieldState[idx].disburse_bal_amt
    : "";

  params.recovered_amount = formFieldState[idx].recovered_amount
    ? formFieldState[idx].recovered_amount
    : "";
  params.cancellation_charges = formFieldState[idx].cancellationChargesVal
    ? formFieldState[idx].cancellationChargesVal
    : "";
  params.money_returned_to_bank = formFieldState[idx].money_returned_to_bank
    ? formFieldState[idx].money_returned_to_bank
    : "";
  params[`release_foreclosure_amount_${payCount}`] = formFieldState[idx]
    .releaseForeclosureAmountVal
    ? formFieldState[idx].releaseForeclosureAmountVal
    : "";
  params[`total_foreclosure_amount_${payCount}`] = formFieldState[idx]
    .totalForeclosureAmountVal
    ? formFieldState[idx].totalForeclosureAmountVal
    : "";
  params[`payable_rtgs_cheque_number_${payCount}`] = formFieldState[idx]
    .payable_rtgs_cheque_number
    ? formFieldState[idx].payable_rtgs_cheque_number
    : "";
  params.disbursed_amount = params[`disburse_payable_amt_${payCount}`];
};

export {
  fillFormValues,
  compareLedgerWithDisbAmtFunction,
  validateOTPFunction,
  addUTRFunction,
  addTrancheFunction,
  balTotalFunction,
  partPaymentSubmissionFunction,
  superMakerSubmissionFunction,
  checkerValidateFunction,
  getCurrentDisbursementAmount,
  otherSubmissionFunction,
  validateTuAccount,
  validatePayeeDetails,
  regexValidate,
  checkBoxValidations,
  getPayerAcVal,
  autoFillByIfsc,
  assignChecker,
  appendErrorClass,
  removeErrorClass,
  resetDealerProfileFields,
  resetPaymentPrefillFields,
  resetPartnerProfileFields,
  resetBankFields,
  getTrancheNo,
  getTrancheClsAndType,
  getFloatColorAndMsg,
  getVerifiedClsAndTxt,
  refreshFloatRuleFunction,
  changeAccTypeFunction,
  cancelPartPaymentFunction,
  validateAccNumberFunction,
  ifscMappingFunction,
  calculateCanAndForeclosure,
  makerSubmissionFunction,
};
